import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import CustomisedSolutions from './images/customized solution icon.png';
import ExperiencedConsultants from './images/Experienced Consultation icon.png';
import HassleFreeProcedure from './images/hustle free icon.png';
import MultiplePaymentOptions from './images/Multiple Payment icon.png';


export default function DMCC() {


    const posts = [
        {
            title: "Mainland Company Setup",
            desc: "Explore limitless possibilities with Dubai Setup expert guidance in Mainland company formation in Dubai.",
        },
        {
            title: "Offshore Company Setup",
            desc: "Offshore companies can be created and owned by individuals or institutions, and shares can be easily and freely transferred by a written instrument.",
        },
        {
            title: "Free Zone Company Setup",
            desc: "Explore boundless opportunities with A&A Associate LLC’s Freezone company formation in Dubai, UAE !",
        },
    ]



    return (
        <>

            <div className='bg-white'>
                <section className="py-14 " style={{ background: "rgb(242, 249, 255)" }}>
                    <div className="max-w-screen-xl mx-auto px-4 md:text-center md:px-8">
                        <div className="max-w-xxl space-y-3 md:mx-auto">
                            <ScrollAnimation animateIn="fadeIn">
                                <h3 className="text-gray-800 text-3xl font-bold sm:text-4xl">
                                    Dubai Multi Commodities Center <span style={{ color: "#1fa1cb" }}>(DMCC) </span>
                                </h3>
                            </ScrollAnimation>
                        </div>
                    </div>
                    <div className="max-w-screen-xl mx-auto px-4  md:px-8 mt-5">
                        <div className="max-w-xxl space-y-3 md:mx-auto">
                            <ScrollAnimation animateIn="fadeIn">
                                <p className="text-gray-600 pb-5">
                                    The Dubai Multi Commodities Centre (DMCC) is a free zone authority in Dubai, United Arab
                                    Emirates (UAE), established in 2002 to enhance commodity trade flows through the Emirate. It's
                                    recognized as one of the world's fastest-growing free zones and the largest and fastest-growing
                                    free economic zone in the UAE. DMCC offers a wide range of services to support businesses
                                    operating within its jurisdiction, including licensing, registration, and various facilities and
                                    infrastructure tailored to different industries. It has become a hub for commodities trading,
                                    including gold, diamonds, pearls, tea, and various other goods. Additionally, DMCC provides a
                                    favorable business environment with state-of-the-art infrastructure, business-friendly
                                    regulations, and strategic location, attracting both local and international companies.
                                </p>
                            </ScrollAnimation>
                            <div className="flex justify-center">
                                <ScrollAnimation animateIn="fadeIn">
                                    <img src="https://elevateauditing.com/wp-content/uploads/2021/10/dmcc-comapny-formation.jpg" className="md:max-w-3xl sm:max-w-xxl sm:rounded-lg" alt="" />
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


            <section className="py-2 mt-5 mb-5" style={{ marginTop: 50 }}>
                <div className="max-w-screen-xl mx-auto px-4">
                    <div className='row' style={{ marginTop: 70 }}>
                        <div className='col '>
                            <div>
                                <ScrollAnimation animateIn="fadeIn">
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 35, marginLeft: 0, lineHeight: 1.2 }}>
                                        Dubai Multi Commodities <br></br>Center <span style={{ color: "#1fa1cb" }}>(DMCC) </span>
                                        Benefits:
                                    </h3>
                                    <p className="text-gray-600 pb-5">
                                        The Dubai Multi Commodities Centre (DMCC) offers several benefits <br></br>to businesses operating
                                        within its jurisdiction:
                                    </p>
                                </ScrollAnimation>
                            </div>
                        </div>
                        <div className='col '>
                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>1</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Free Zone <span style={{ color: "#1fa1cb" }}>Advantages</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal', }}>
                                            DMCC is a free zone, providing businesses with 100% ownership
                                            and full repatriation of profits and capital.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>2</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Strategic <span style={{ color: "#1fa1cb" }}>Location</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            Dubai is strategically located between the East and the West, serving
                                            as a gateway to regional and international markets.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>3</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        World-Class  <span style={{ color: "#1fa1cb" }}>Infrastructure</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            DMCC offers modern infrastructure and facilities tailored to
                                            various industries, including offices, warehouses, and trading platforms.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>4</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Business-Friendly <span style={{ color: "#1fa1cb" }}>Regulations</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            DMCC has a robust regulatory framework that supports
                                            business growth while ensuring transparency and compliance.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>5</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Access to <span style={{ color: "#1fa1cb" }}>Markets</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            Businesses in DMCC benefit from access to a wide range of markets,
                                            including the Middle East, Africa, Asia, and beyond.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>


                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>6</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Networking <span style={{ color: "#1fa1cb" }}>Opportunities</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            DMCC provides ample networking opportunities through
                                            events, seminars, and networking platforms, facilitating business connections and
                                            collaborations.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>


                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>7</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Tax <span style={{ color: "#1fa1cb" }}>Incentives</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            DMCC offers tax incentives, including zero corporate and personal
                                            income tax for a specified period, making it attractive for businesses seeking tax
                                            efficiency.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>8</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Industry <span style={{ color: "#1fa1cb" }}>Focus</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            DMCC specializes in commodities trading and related industries,
                                            offering specialized services and support tailored to these sectors.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>


                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>9</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Integrated <span style={{ color: "#1fa1cb" }}>Services</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            DMCC provides a range of integrated services, including licensing,
                                            registration, banking, insurance, and logistics support, simplifying the setup and
                                            operation of businesses.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>10</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Quality of <span style={{ color: "#1fa1cb" }}>Life</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            Dubai offers a high quality of life with modern amenities, a diverse
                                            cultural scene, and a safe and stable environment, making it an attractive destination
                                            for businesses and professionals alike.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>
            </section >




            <div className='bg-white' style={{ paddingTop: 40 }}>
                <section className="py-2 mt-5 mb-5" >
                    <div className="max-w-screen-xl mx-auto px-4">
                        <ScrollAnimation animateIn="fadeIn">
                            <h3 className="text-gray-600 text-2xl font-bold sm:text-3xl pb-1 text-center">
                                Why <span style={{ color: "#1fa1cb" }}>Us?</span>
                            </h3>
                        </ScrollAnimation>
                    </div>
                </section>

                <section className="py-2 mt-5 mb-5 " style={{ marginTop: 30, paddingBottom: 50, display: "flex" }}>
                    <div className="max-w-screen-xl mx-auto px-4">
                        <div className='row whyus-md'> {/* Changed from d-flex justify-content-center to text-center */}
                            <div className='col-md-4 mb-5' style={{ marginRight: '8rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <img
                                        width="55"
                                        height="55"
                                        alt=""
                                        className="attachment-full size-full wp-image-7327 lazyloaded"
                                        decoding="async"
                                        nitro-lazy-empty=""
                                        id="ODUxODoyNzY=-1"
                                        src={CustomisedSolutions} />

                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-1" style={{ fontSize: 24, marginLeft: 15, lineHeight: 1 }}>
                                        Customised <br></br><span style={{ color: "#1fa1cb" }}>Solutions</span>
                                    </h3>
                                </div>
                            </div>
                            <div className='col-md-4 mb-5' style={{ marginRight: '8rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <img
                                        width="55"
                                        height="55"
                                        alt=""
                                        className="attachment-full size-full wp-image-7329 lazyloaded"
                                        decoding="async"
                                        nitro-lazy-empty=""
                                        id="ODUyNjoyNzY=-1"
                                        src={ExperiencedConsultants}
                                    />
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-1" style={{ fontSize: 24, marginLeft: 15, lineHeight: 1 }}>
                                        Experienced <br></br><span style={{ color: "#1fa1cb" }}>Consultants</span>
                                    </h3>
                                </div>
                            </div>
                            <div className='col-md-4 mb-5' style={{ marginRight: '8rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <img width="55" height="55" alt="" class="attachment-full wp-image-7326 lazyloaded" decoding="async" nitro-lazy-empty="" id="ODg3MzoyNzY=-1" src={HassleFreeProcedure} />
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-1" style={{ fontSize: 24, marginLeft: 15, lineHeight: 1 }}>
                                        Hassle-Free <br></br><span style={{ color: "#1fa1cb" }}>Procedure</span>
                                    </h3>
                                </div>
                            </div>
                            <div className='col-md-4 mb-5' >
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <img width="55" height="55" alt="" class="attachment-full wp-image-7328 lazyloaded" decoding="async" id="ODg4MToyNzY=-1" src={MultiplePaymentOptions} />
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-1" style={{ fontSize: 24, marginLeft: 15, lineHeight: 1 }}>
                                        Multiple Payment <br></br><span style={{ color: "#1fa1cb" }}>Options</span>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


            <div className="max-w-screen-xxl mx-auto" style={{ paddingBottom: 40, paddingTop: 40, background: "rgb(242, 249, 255)" }}>
                <section className="py-2 mt-5 ">
                    <div className="max-w-screen-xl mx-auto px-4">
                        <ScrollAnimation animateIn="fadeIn">
                            <h3 className="text-gray-600 text-2xl font-bold sm:text-3xl pb-1 text-center">
                                Our Other <span style={{ color: "#1fa1cb" }}>Services</span>
                            </h3>
                            <p className="text-gray-600 mt-2 text-center font-semibold" style={{ fontSize: 18 }}>
                                Also you can find our Other Services here.
                            </p>
                        </ScrollAnimation>
                    </div>
                </section>

                <div className="max-w-screen-xl mx-auto">
                    <div className=" grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
                        {
                            posts.map((items, key) => (
                                <article className="max-w-md mx-auto mt-4 shadow-lg border rounded-md duration-300 hover:shadow-sm bg-white our-other-service" key={key}>
                                    <div className='p-5' >
                                        <a href={items.href}>
                                            <div className="pt-3 ml-4 mr-2 mb-3">
                                                <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-1 " style={{ color: "#1fa1cb" }}>
                                                    {items.title}
                                                </h3>
                                                <p className="text-gray-400 text-sm mt-1 " style={{ fontSize: 14 }}>{items.desc}</p>
                                            </div>
                                        </a>
                                    </div>
                                </article>
                            ))
                        }
                    </div>
                </div>
            </div>


            <div className='mb-5'>
                <section className="py-14">
                    <div className="max-w-screen-xl mx-auto md:px-8">
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
                            <div className="flex-1 sm:hidden lg:block" style={{ marginBottom: 200 }}>
                                <div className="fb-iframe-container">
                                    <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fweb.facebook.com%2Fdubaisetupinfo.co&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                                        width="1240" height="500" className='fb-frame' style={{ border: 'none', overflow: 'hidden' }} scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                                </div>
                            </div>
                            <div className="max-w-xl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xl">
                                <div className="fb-container-text">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-4xl mb-5">
                                        Dubai Setup  <span className="text-customLightBlue">Facebook Page</span>
                                    </h3>
                                    <p className="text-gray-900 text-1xl font-normal sm:text-1xl ">
                                        This company's Facebook page is a testament to their dedication to excellence, fostering a vibrant community, and showcasing their creativity. With captivating content and interactive engagement, they go beyond mere promotion, building genuine connections with their audience. Each post tells a story, evoking emotions and leaving a lasting impression on followers. Their commitment to innovation shines through in every aspect of their page, setting them apart from the competition. Moreover, they prioritize customer satisfaction, ensuring transparency and authenticity in all interactions. Their page serves as a window into their values and aspirations, inspiring trust and loyalty among their followers. Overall, this company's Facebook presence embodies their passion for making a difference and leaves a lasting impact on all who engage with it.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


        </>
    )
}
